export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB in bytes
export const MAX_TOTAL_SIZE = 200 * 1024 * 1024; // 200MB in bytes 